
import { z } from "zod";

export const NotificationTypeValues = ["CONVERSATION_ITEM_MENTION", "CONVERSATION_ITEM_GROUP_MENTION", "CONVERSATION_ITEM_ORGANIZATION_MENTION", "CONVERSATION_ITEM_REPLY", "CONVERSATION_ITEM_REACTION", "CONVERSATION_ITEM_CONVERSATION_SUBSCRIBED", "TICKET_SUBSCRIBED_STATUS_CHANGE", "TICKET_SUBSCRIBED_URGENT_PRIORITY_CHANGE", "TICKET_ASSIGNED_URGENT_ASSIGNMENT_CHANGE", "TICKET_ASSIGNED_ASSIGNMENT_CHANGE", "TICKET_SUBSCRIBED_SNOOZED", "TICKET_SUBSCRIBED_URGENT_SNOOZED", "ESCALATION_SUBSCRIBED_STATUS_CHANGE", "ESCALATION_SUBSCRIBED_RISK_TIER_CHANGE", "ESCALATION_ASSIGNED_ASSIGNMENT_CHANGE", "ESCROW_STATUS_CHANGE", "FINANCING_STATUS_CHANGE", "HIC_STATUS_CHANGE", "EXTERNAL_PARTNER_MENTION", "NEW_WORK_ORDER", "SLA_ALERTS"] as const;
export const NotificationTypeSchema = z.enum(NotificationTypeValues);
export const NotificationType = NotificationTypeSchema.enum;
export type NotificationType = (typeof NotificationTypeValues)[number];
export const NotificationTypeDisplayNames = { "CONVERSATION_ITEM_MENTION": "Mentions",
"CONVERSATION_ITEM_GROUP_MENTION": "Team mentions",
"CONVERSATION_ITEM_ORGANIZATION_MENTION": "Organization mentions",
"CONVERSATION_ITEM_REPLY": "Thread replies",
"CONVERSATION_ITEM_REACTION": "Reactions",
"CONVERSATION_ITEM_CONVERSATION_SUBSCRIBED": "Subscribed conversation messages",
"TICKET_SUBSCRIBED_STATUS_CHANGE": "Ticket status changes",
"TICKET_SUBSCRIBED_URGENT_PRIORITY_CHANGE": "Tickets marked urgent",
"TICKET_ASSIGNED_URGENT_ASSIGNMENT_CHANGE": "Urgent ticket assignments",
"TICKET_ASSIGNED_ASSIGNMENT_CHANGE": "Ticket assignment changes",
"TICKET_SUBSCRIBED_SNOOZED": "Ticket snooze changes",
"TICKET_SUBSCRIBED_URGENT_SNOOZED": "Urgent ticket snooze changes",
"ESCALATION_SUBSCRIBED_STATUS_CHANGE": "Escalation status changes",
"ESCALATION_SUBSCRIBED_RISK_TIER_CHANGE": "Escalation risk tier changes",
"ESCALATION_ASSIGNED_ASSIGNMENT_CHANGE": "Escalation assignment changes",
"ESCROW_STATUS_CHANGE": "Escrow status changes",
"FINANCING_STATUS_CHANGE": "Financing status changes",
"HIC_STATUS_CHANGE": "HIC status changes",
"EXTERNAL_PARTNER_MENTION": "Partner mention emails",
"NEW_WORK_ORDER": "New work order",
"SLA_ALERTS": "Job texts", } satisfies Record<NotificationType, string>;
